export const odluka_zvizdaci = {
    templateId: 230.1,
    category: 3,
    templateTitle: 'Odluka o imenovanju povjerljive osobe i njezina zamjenika (Zakon o zaštiti prijavitelja nepravilnosti)',
    templateDescription: `<p>Poslodavac koji zapošljava najmanje 50 radnika (te drugi Zakonom određeni poslodavci) dužni su sukladno Zakonu o zaštiti prijavitelja nepravilnosti (tzv. "Zakon o zviždačima") imenovati povjerljivu osobu i zamjenika povjerljive osobe za unutarnje prijavljivanje nepravilnosti.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA DOKUMENTA</strong></h5>
    <p>Zakonom o zaštiti prijavitelja nepravilnosti (tzv. "Zakon o zviždačima"; dalje u tekstu: "Zakon") uređuje se prijavljivanje nepravilnosti, postupak prijavljivanja nepravilnosti, prava osoba u postupku prijavljivanja, obveze tijela javne vlasti te pravnih i fizičkih osoba u vezi s prijavom nepravilnosti, kao i druga pitanja.</p>
    <p>Poslodavac, u smislu spomenutog zakona je:</p>
    <li> tijelo javne vlasti,</li>
    <li> fizička ili pravna osoba (prema zakonu kojim se uređuju radni odnosi) kod koje prijavitelj nepravilnosti obavlja profesionalne aktivnosti u radnom okruženju.</li>
    <br> 
    <p>U tom smislu,<strong> poslodavac koji zapošljava najmanje 50 radnika dužan je uspostaviti sustav unutarnjeg prijavljivanja nepravilnosti, no svakako i poslodavci koji zapošljavaju manje od 50 radnika mogu imati uspostavljen sustav unutarnjeg prijavljivanja nepravilnosti.</strong></p>
    <p>Poslodavac koji je obuhvaćen primjenom akata iz dijela I. točke B. i dijela II. Priloga Zakona <strong>dužan</strong> je uspostaviti sustav unutarnjeg prijavljivanja nepravilnosti neovisno o broju zaposlenih.</p>

    <p>Osim obveze donošenja općeg akta kojim se uređuje postupak unutarnjeg prijavljivanja nepravilnosti, poslodavac je dužan urediti i postupak imenovanja povjerljive osobe i njezina zamjenika (primjer općeg akta/pravilnika kojim se uređuje navedeno možete pogledati <a class="local-link" href="/contract?template=220.1">ovdje</a>).</p>

    <p>Pravni subjekti u privatnom sektoru te trgovačka društva iz članka 6. točke 7. Zakona koji imaju između 50 i 249 radnika mogu dijeliti resurse u pogledu primitka prijava i vođenja postupka, pod uvjetima predviđenim ovim Zakonom i nacionalnim pravom u području radnih odnosa.</p>

    <p><strong>U skladu s navedenim, poslodavac je dužan imenovati imenovati povjerljivu osobu i njezina zamjenika u skladu s općim aktom. </p>
    <p>Povjerljiva osoba imenuje se od strane poslodavca radi zaprimanja prijava nepravilnosti, komunikacije s prijaviteljem i vođenja postupka zaštite u vezi s prijavom nepravilnosti</strong>.</p>
    <p>Povjerljiva osoba može biti fizička osoba <strong>zaposlena kod poslodavca ili treća fizička osoba</strong>.</p>
    <p>Imenovanje povjerljive osobe i njenog zamjenika Poslodavac obavlja na prijedlog:</p>
    <li> radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća, </li>
    <li> najmanje 20% radnika zaposlenih kod poslodavca, ako radničko vijeće ili sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća nisu ustanovljeni pri poslodavcu.</li>
    <br> 

    <p>U slučaju više prijedloga radnika, prednost će imati prijedlog koji ima veću podršku radnika, a u slučaju prijedloga koji imaju jednaku podršku radnika, prednost će imati prijedlog koji je prvi zaprimljen.</p>
    
    <p>No, poslodavac je <strong>dužan imenovati povjerljivu osobu i njezina zamjenika bez prijedloga radničkog vijeća ili sindikalnog povjerenika</strong> koji je preuzeo prava i obveze radničkog vijeća odnosno najmanje 20% radnika zaposlenih kod poslodavca <strong>ako takav prijedlog nije dan.</strong></p>
  
    <p>Povjerljiva osoba i njezin zamjenik moraju dati pisanu suglasnost za imenovanje.</strong> </p>
    <p>Imenovanu povjerljivu osobu i njezina zamjenika poslodavac će razriješiti bez odgađanja na temelju prijedloga radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća odnosno najmanje 20% radnika zaposlenih kod poslodavca.</p>
    <p>Poslodavac će pokrenuti postupak za imenovanje povjerljive osobe i njezina zamjenika najkasnije u roku od 30 dana od razrješenja povjerljive osobe i njezina zamjenika, a do donošenja odluke o imenovanju nove povjerljive osobe, poslove povjerljive osobe obavlja njezin zamjenik, osim ako okolnosti upućuju na to da je potrebno imenovati treću osobu da privremeno obavlja poslove povjerljive osobe.</p>
    <p>Dokument u nastavku predstavlja primjer odluke o imenovanju povjerljive i zamjenika osobe.</p>

    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o zaštiti prijavitelja nepravilnosti.</p>

  `,
  sides: [
    {
      prefix: 'Na temelju Zakona o zaštiti prijavitelja nepravilnosti (dalje u tekstu: "Zakon") te Pravilnika Poslodavca kojim se uređuje postupak imenovanja osoba za unutarnje prijavljivanje nepravilnosti,',
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslodavac",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: 'donosi sljedeću',
  title: 'ODLUKU O IMENOVANJU POVJERLJIVE OSOBE I ZAMJENIKA POVJERLJIVE OSOBE',

  noArticleNumbers: true,

  articles: [

    {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
              { type: "text", content: "Sukladno odredbama Zakona i Općeg akta Poslodavca, za povjerljivu osoba koja zaprima prijave nepravilnosti, obavlja komunikaciju s prijaviteljem i vodi postupak zaštite u vezi s prijavom nepravilnosti imenuje se" },
              { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"},
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'input', value: '', required: true, placeholder: "broj telefona" },
                { type: "text", content: "," },  
                { type: 'input', value: '', required: true, placeholder: "adresa elektroničke pošte" },
                { type: "text", content: "," },  
                { type: 'text', content: '(u daljnjem tekstu: Povjerljiva osoba).'},
            ]
          }]
      },
      {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
              { type: "text", content: "Sukladno odredbama Zakona i Općeg akta Poslodavca, za zamjenika povjerljive osoba koja zaprima prijave nepravilnosti, obavlja komunikaciju s prijaviteljem i vodi postupak zaštite u vezi s prijavom nepravilnosti imenuje se" },
              { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
              { type: "text", content: "," },
              { type: 'text', content: 'iz',},
              { type: 'input', value: '', required: true, placeholder: "Mjesto"},
              { type: 'text', content: ',' },
              { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
              { type: "text", content: "," },
              { type: 'input', value: '', required: true, placeholder: "broj telefona" },
              { type: "text", content: "," },  
              { type: 'input', value: '', required: true, placeholder: "adresa elektroničke pošte" },
              { type: "text", content: "," },
                { type: 'text', content: '(u daljnjem tekstu: Zamjenik povjerljive osobe).'},
            ]
          }]
      },
      {
        title: '',
        mandatory: false,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Povjerljiva osoba i njezin zamjenik moraju svoje dužnosti obavljati zakonito (sukladno odredbama Zakona o zaštiti prijevitelja nepravilnosti i Općeg akta Poslodavca) i savjesno i ne smiju zlouporabiti svoje ovlasti na štetu prijavitelja nepravilnosti.'
          }]
      },
      {
        title: '',
        mandatory: false,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Povjerljiva osoba te njezin zamjenik imaju pravo na zaštitu identiteta i povjerljivosti te sudsku zaštitu ako učine vjerojatnim da je prema njima počinjena ili pokušana osveta, ili im se prijetilo osvetom zbog zaprimanja prijave o nepravilnosti odnosno postupanja po zaprimljenoj prijavi. '
          }]
      },
  
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "Poslodavac je zaprimio prijedlog radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća za imenovanjem povjerljive osobe i zamjenika povjerljive osobe.",
            "S obzirom da radničko vijeće ili sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća nisu ustanovljeni kod Poslodavca, Poslodavac je zaprimio prijedlog najmanje 20% radnika zaposlenih kod Poslodavca za imenovanjem povjerljive osobe i zamjenika povjerljive osobe.",
            "Budući da Poslodavac nije zaprimio prijedlog za imenovanje povjerljive osobe i zamjenika povjerljive osobe u skladu s odredbama Zakona i Općeg akta Poslodavca, Poslodavac ovom Odlukom samostalno imenuje povjerljivu osobu i zamjenika povjerljive osobe.",
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        },
      ]
    },
    {
      title: '',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Sukladno prethodno navedenom, Poslodavac imenuje gore navedene osobe u izreci ovog rješenja za povjerljivu osobu odnosno zamjenika povjerljive osobe.`,
        }]
    },
    {
      title: '',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Povjerljiva osoba i njezin zamjenik moraju svoje dužnosti obavljati zakonito i savjesno i ne smiju zlouporabiti svoje ovlasti na štetu prijavitelja nepravilnosti.
          `,
        }]
    },
    {
      title: '',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Imenovanu povjerljivu osobu i njezina zamjenika Poslodavac će razriješiti bez odgađanja na temelju prijedloga radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća odnosno najmanje 20% radnika zaposlenih kod Poslodavca.`,
        }]
    },
  {
    title: '',
    mandatory: true,
    dummy: true,
    statements: [
      {
        type: 'text',
        mandatory: true,
        editable: true,
        content: `Povjerljiva osoba i zamjenik povjerljive osobe, potpisom primitka ove Odluke potvrđuju da su dale suglasnost na imenovanje, a sukladno odredbama Zakona te Općeg akta Poslodavca kojim je reguliran postupak unutarnjeg prijavljivanja nepravilnosti.\r\nOsim toga, povjerljiva osoba i zamjenik povjerljive osobe potvrđuju da su upoznati s odredbama navedenog Zakona i Općeg akta Poslodavca.`,
      }]
  },
    {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: `U skladu s naprijed navedenim, odlučeno je kao u izreci ove Odluke.`,
          }]
      },
      {
        title: '',
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Ova Odluka stupa na snagu danom donošenja.'
          }]
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signature
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Povjerljiva osoba \r\n2) Zamjenik povjerljive osobe \r\n3) Kadrovska evidencija \r\n\r\nObavijest o odluci: Oglasna ploča',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/230.1_odluka_zvizdaci.ts